import {useEffect, useState} from "react";

import {PreferencesSurveySource} from "@pg-rp/common-types";

import {HomeMatchAmplitudeLocation} from "@/features/tracking/amplitude/home_match_amplitude_tracker";
import {useGetUserProfileQuery} from "@/features/user/api/user_api";

import {useGetHomeMatchPreferencesQuery} from "../../api/get_home_match_preferences";
import {useHomeMatchPreferencesWithRegions} from "../../hooks/preferences/use_home_match_preferences_with_regions";
import {IHomeMatchPreferencesWizardRequest} from "../../hooks/use_home_match_tinder_unlock";
import {getHomeMatchPreferencesWizardSteps, IHomeMatchPreferencesWizardPlan} from "../../utils/get_home_match_preferences_wizard_steps";
import {HomeMatchPreferencesWizardSurvey} from "./HomeMatchPreferencesWizardSurvey";

interface IProps {
    amplitudeLocation?: HomeMatchAmplitudeLocation;
    isOpen: boolean;
    onClose: () => void;
    onOpenFullSurvey?: () => void;
    onSurveyStepsDone: () => void;
    preferencesSurveySource: PreferencesSurveySource;
    request: IHomeMatchPreferencesWizardRequest | null;
    zIndex?: number;
}

export const HomeMatchPreferencesWizardHost = (props: IProps) => {
    const {
        amplitudeLocation = HomeMatchAmplitudeLocation.DASHBOARD,
        isOpen,
        onClose,
        onOpenFullSurvey,
        onSurveyStepsDone,
        preferencesSurveySource,
        request,
        zIndex
    } = props;
    const {data: preferences, isLoading: isPreferencesLoading} = useGetHomeMatchPreferencesQuery();
    const {preferences: formPreferences, regionDetails} = useHomeMatchPreferencesWithRegions();
    const {data: userProfile, isLoading: isProfileLoading} = useGetUserProfileQuery();
    const [displayedRequest, setDisplayedRequest] = useState(request);
    const [plan, setPlan] = useState<IHomeMatchPreferencesWizardPlan | null>(null);
    const [planRequest, setPlanRequest] = useState(request);
    const canBuildPlan = Boolean(request) && !isPreferencesLoading && !isProfileLoading;
    const visibleRequest = request ?? displayedRequest;

    const buildPlan = (nextRequest: IHomeMatchPreferencesWizardRequest) =>
        getHomeMatchPreferencesWizardSteps({
            entry: nextRequest.entry,
            phone: userProfile?.phone ?? null,
            phoneVerified: Boolean(userProfile?.phone_verified),
            startStep: nextRequest.startStep,
            survey: preferences ?? null
        });

    if (request && request !== displayedRequest) {
        setDisplayedRequest(request);
    }

    if (!request && displayedRequest && (!plan || plan.steps.length === 0)) {
        setDisplayedRequest(null);
    }

    if (request && request !== planRequest) {
        setPlanRequest(request);
        setPlan(canBuildPlan && request ? buildPlan(request) : null);
    } else if (request && !plan && canBuildPlan) {
        setPlan(buildPlan(request));
    }

    useEffect(() => {
        if (plan?.steps.length === 0) onClose();
    }, [onClose, plan]);

    useEffect(() => {
        if (request || !displayedRequest) return;

        const timeout = window.setTimeout(() => setDisplayedRequest(null), 200);

        return () => window.clearTimeout(timeout);
    }, [displayedRequest, request]);

    if (!visibleRequest || !plan || plan.steps.length === 0 || (request && isPreferencesLoading && !preferences)) return null;

    return (
        <HomeMatchPreferencesWizardSurvey
            additionalAreas={preferences?.additional_areas ?? null}
            amplitudeLocation={amplitudeLocation}
            area={preferences?.area ?? null}
            entry={visibleRequest.entry}
            financingPreference={preferences?.financing_preference ?? null}
            isOpen={Boolean(request) && isOpen}
            onClose={onClose}
            onOpenFullSurvey={onOpenFullSurvey}
            onSurveyStepsDone={onSurveyStepsDone}
            phone={userProfile?.phone ?? null}
            preferencesSurveySource={preferencesSurveySource}
            regionDetails={regionDetails}
            regionOptions={formPreferences?.regions ?? []}
            returnsToSummary={Boolean(visibleRequest?.returnsToSummary)}
            steps={plan.steps}
            survey={preferences ?? null}
            zIndex={zIndex}
        />
    );
};
import {useEffect, useState} from "react";

import {PreferencesSurveySource} from "@pg-rp/common-types";

import {HomeMatchAmplitudeLocation} from "@/features/tracking/amplitude/home_match_amplitude_tracker";
import {useGetUserProfileQuery} from "@/features/user/api/user_api";

import {useGetHomeMatchPreferencesQuery} from "../../api/get_home_match_preferences";
import {useHomeMatchPreferencesWithRegions} from "../../hooks/preferences/use_home_match_preferences_with_regions";
import {IHomeMatchPreferencesWizardRequest} from "../../hooks/use_home_match_tinder_unlock";
import {getHomeMatchPreferencesWizardSteps, IHomeMatchPreferencesWizardPlan} from "../../utils/get_home_match_preferences_wizard_steps";
import {HomeMatchPreferencesWizardSurvey} from "./HomeMatchPreferencesWizardSurvey";

interface IProps {
    amplitudeLocation?: HomeMatchAmplitudeLocation;
    isOpen: boolean;
    onClose: () => void;
    onOpenFullSurvey?: () => void;
    onSurveyStepsDone: () => void;
    preferencesSurveySource: PreferencesSurveySource;
    request: IHomeMatchPreferencesWizardRequest | null;
    zIndex?: number;
}

export const HomeMatchPreferencesWizardHost = (props: IProps) => {
    const {
        amplitudeLocation = HomeMatchAmplitudeLocation.DASHBOARD,
        isOpen,
        onClose,
        onOpenFullSurvey,
        onSurveyStepsDone,
        preferencesSurveySource,
        request,
        zIndex
    } = props;
    const {data: preferences, isLoading: isPreferencesLoading} = useGetHomeMatchPreferencesQuery();
    const {preferences: formPreferences, regionDetails} = useHomeMatchPreferencesWithRegions();
    const {data: userProfile, isLoading: isProfileLoading} = useGetUserProfileQuery();
    const [displayedRequest, setDisplayedRequest] = useState(request);
    const [plan, setPlan] = useState<IHomeMatchPreferencesWizardPlan | null>(null);
    const [planRequest, setPlanRequest] = useState(request);
    const canBuildPlan = Boolean(request) && !isPreferencesLoading && !isProfileLoading;
    const visibleRequest = request ?? displayedRequest;

    const buildPlan = (nextRequest: IHomeMatchPreferencesWizardRequest) =>
        getHomeMatchPreferencesWizardSteps({
            entry: nextRequest.entry,
            phone: userProfile?.phone ?? null,
            phoneVerified: Boolean(userProfile?.phone_verified),
            startStep: nextRequest.startStep,
            survey: preferences ?? null
        });

    if (request && request !== displayedRequest) {
        setDisplayedRequest(request);
    }

    if (!request && displayedRequest && (!plan || plan.steps.length === 0)) {
        setDisplayedRequest(null);
    }

    if (request && request !== planRequest) {
        setPlanRequest(request);
        setPlan(canBuildPlan && request ? buildPlan(request) : null);
    } else if (request && !plan && canBuildPlan) {
        setPlan(buildPlan(request));
    }

    useEffect(() => {
        if (plan?.steps.length === 0) onClose();
    }, [onClose, plan]);

    useEffect(() => {
        if (request || !displayedRequest) return;

        const timeout = window.setTimeout(() => setDisplayedRequest(null), 200);

        return () => window.clearTimeout(timeout);
    }, [displayedRequest, request]);

    if (!visibleRequest || !plan || plan.steps.length === 0 || (request && isPreferencesLoading && !preferences)) return null;

    return (
        <HomeMatchPreferencesWizardSurvey
            additionalAreas={preferences?.additional_areas ?? null}
            amplitudeLocation={amplitudeLocation}
            area={preferences?.area ?? null}
            entry={visibleRequest.entry}
            financingPreference={preferences?.financing_preference ?? null}
            isOpen={Boolean(request) && isOpen}
            onClose={onClose}
            onOpenFullSurvey={onOpenFullSurvey}
            onSurveyStepsDone={onSurveyStepsDone}
            phone={userProfile?.phone ?? null}
            preferencesSurveySource={preferencesSurveySource}
            regionDetails={regionDetails}
            regionOptions={formPreferences?.regions ?? []}
            returnsToSummary={Boolean(visibleRequest?.returnsToSummary)}
            steps={plan.steps}
            survey={preferences ?? null}
            zIndex={zIndex}
        />
    );
};
